import { TFilterValue } from "@irohana-dev/components";
import { Dayjs } from "dayjs";
import { asStringArray, fromDateRangeValue, toDateRangeValue } from "@/components/commons/filter-condition/filter-condition-adapter-kit";
import {
  MULTI_SELECT_FILTER_KEYS,
  TCaseListFilterFormExtended,
  defaultCaseListFilterValues,
} from "@/features/case/components/CaseList/case-list-filter-shared";

export const CASE_LIST_DATE_RANGE_KEY = "registrationDate";

export const toFilterValue = (filters: TCaseListFilterFormExtended): TFilterValue => {
  const value: TFilterValue = {};
  for (const [key, raw] of Object.entries(filters)) {
    if (key === "registrationDateFrom" || key === "registrationDateTo") continue;
    if (Array.isArray(raw)) {
      if (raw.length > 0) value[key] = raw.map(String);
      continue;
    }
    if (raw === "" || raw === null || raw === undefined) continue;
    if (MULTI_SELECT_FILTER_KEYS.includes(key as keyof TCaseListFilterFormExtended)) {
      value[key] = [String(raw)];
      continue;
    }
    value[key] = String(raw);
  }
  const range = toDateRangeValue(filters.registrationDateFrom, filters.registrationDateTo);
  if (range) value[CASE_LIST_DATE_RANGE_KEY] = range;
  return value;
};

export const fromFilterValue = (value: TFilterValue): TCaseListFilterFormExtended => {
  const { from, to } = fromDateRangeValue(value, CASE_LIST_DATE_RANGE_KEY);
  return {
    ...defaultCaseListFilterValues,
    caseStatus: asStringArray(value.caseStatus),
    managementNumber: (value.managementNumber as string) ?? "",
    caseName: (value.caseName as string) ?? "",
    jobName: (value.jobName as string) ?? "",
    companyName: asStringArray(value.companyName),
    companySpecificIndustryId: asStringArray(value.companySpecificIndustryId),
    workplaceProvinceCode: asStringArray(value.workplaceProvinceCode),
    workplaceMunicipalityCode: asStringArray(value.workplaceMunicipalityCode),
    recruitmentNumber: asStringArray(value.recruitmentNumber),
    caseMatchCount: asStringArray(value.caseMatchCount),
    personInChargeId: asStringArray(value.personInChargeId),
    registrationDateFrom: from as Dayjs | null,
    registrationDateTo: to as Dayjs | null,
  };
};
